<template>
  <div>
    <h1>Hups, ei löytynyt täältä.</h1>
    <p>Takaisin <router-link class="homelink" to="/">alkuun</router-link>.</p>
  </div>
</template>
<script>
export default {
  name: "PageNotFound",
  components: {}
};
</script>

<style scoped></style>
